export default __webpack_public_path__ + "static/media/scattered-pieces.cb6ab08a.svg";